module.exports = __webpack_public_path__ + "img/2.8b03a44a.jpg";